import { ServiceTypeEnum } from '../../service/enums/service-type.enum';
import { AttendanceServiceEnum } from '../enums/attendance-cau.enum';
import { AttendanceContractTypeEnum } from '../enums/attendance-contract-type.enum';
import { AttendanceDay } from './attendance-day.model';
import { AttendanceStatusItem } from './attendance-status-item.model';

export class AttendanceCAU {
  serviceId: ServiceTypeEnum;
  year: number;
  month: number;
  proposalAttendanceCaus: ProposalAttendanceCau[];
  proposalErrorMap: ProposalErrorMap[];
  schoolName: string;
  initialDiscrepancies: number;
}

export class ProposalAttendanceCau {
  studentId: number;
  familyId: number;
  studentName: string;
  attendanceContractTypeEnum: AttendanceContractTypeEnum;
  totalDaysCau: number;
  totalDaysAMK: number;
  canceledDaysCau: number;
  canceledDaysAMK: number;
  totalAttendanceCAU: number;
  totalAttendanceAMK: number;
  totalParentPriceCAU: number;
  totalParentPriceAMK: number;
  totalCenterPriceCAU: number;
  totalCenterPriceAMK: number;
  attendanceDays: AttendanceDay[];
  proposalDays: AttendanceDay[];
}

export class ProposalErrorMap {
  familyId: number; 
  familyIdentification: string; 
  familyName: string; 
  studentCauCode: string;
  studentName: string;
  studentPhone: string; 
  studentContractTypeEnum: AttendanceContractTypeEnum;
  scholarship: number; 
  reason: string;
}

export class WorkingAttendanceCau {
  index: number;
  studentId: number;
  familyId: number;
  exerciseId: number;
  studentName: string;
  attendanceContractTypeAMK: AttendanceContractTypeEnum;
  attendanceContractTypeCAU: AttendanceContractTypeEnum;
  scholarshipCau: number;
  scholarshipAMK: number;
  totalDaysCau: number;
  totalDaysAMK: number;
  canceledDaysCau: number;
  canceledDaysAMK: number;
  totalAttendanceCAU: number;
  totalAttendanceAMK: number;
  totalParentPriceCAU: number;
  totalParentPriceAMK: number;
  totalCenterPriceCAU: number;
  totalCenterPriceAMK: number;
  attendanceDays: AttendanceStatusItem[];
  hasDiscrepancies: boolean;
  showProposalButton: boolean; 
  isProcessing: boolean;
  isEdited: boolean;
}

export class AttendanceCAUResponse {
  studentId: number;
  serviceId: number;
  year: number;
  month: number;
  attendanceContractTypeEnum: AttendanceContractTypeEnum;
  proposalDays: AttendanceDay[];
}

export class AttendanceCauRequest {
  cauFile: string;
  month: number;
  year: number;
  exerciseId: number;
}

export class PresenceDay {
  day: number;
  attendanceService: AttendanceServiceEnum;
  constructor(day: number, attendanceService: AttendanceServiceEnum) {
    this.day = day;
    this.attendanceService = attendanceService;
  }
}

export class AttendanceCAUFile {
  attendanceCAUFileId: string;
  schoolName: string;
  cauCenterCode: string;
  creationDate: string;
  creationUser: string;
  updateDate: string;
  status: string;
}

export class AttendanceCauFileAddForm {
  ExerciseId: number;
  Year: number;
  Month: number;
  CauFile: string;
  FileName: string;
}

export class AttendanceCauFileRequest {
  ExerciseId: number;
  Year: number;
  Month: number;
  CauFile: string;
  FileName: string;
}
